import { render, staticRenderFns } from "./premium.vue?vue&type=template&id=709b3abe&scoped=true"
import script from "./premium.vue?vue&type=script&setup=true&lang=js"
export * from "./premium.vue?vue&type=script&setup=true&lang=js"
import style0 from "./premium.vue?vue&type=style&index=0&id=709b3abe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709b3abe",
  null
  
)

export default component.exports